import { JsonRPCService } from 'gw-portals-transport-js';
import { getProxiedServiceUrl } from 'gw-portals-url-js';

function getDefaqtoData() {
    return JsonRPCService.send(getProxiedServiceUrl('quote'), 'getDefaqtoData_Ext', [], {});
}

export default {
    getDefaqtoData
};
